export default function Services() {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/6a181c49a3560e68408cccf4891cffc1.jpg',
      type: 'FLEET MANAGEMENT',
      title: 'Own Fleet Operations',
      description: 'TMI operates its own fleet of heavy-duty trucks specifically designed for transporting raw chrome materials and finished products. Our fleet ensures reliable, timely delivery with full control over quality and scheduling.',
      capacity: 'Own',
      unit: 'FLEET',
      features: [
        'Company-owned trucks',
        'Specialized chrome transport',
        'Regular maintenance program',
        'Experienced drivers'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=mining%20raw%20materials%20being%20loaded%20onto%20transport%20truck%20at%20mine%20site%2C%20chrome%20ore%20transportation%2C%20industrial%20loading%20operation%2C%20efficient%20material%20handling%2C%20professional%20mining%20logistics%20photography&width=480&height=320&seq=tmi-logistics-2&orientation=landscape',
      type: 'RAW MATERIAL TRANSPORT',
      title: 'Mine-to-Plant Delivery',
      description: 'Efficient transportation of raw chrome materials from multiple mine sites located 70-120km from our Rustenburg processing plant. We coordinate pickups from various mines and dumps across Northwest Province.',
      capacity: '120km',
      unit: 'RADIUS',
      features: [
        'Multiple mine site pickups',
        'ROM and tailings transport',
        'Coordinated scheduling',
        'Load optimization'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=chrome%20concentrate%20finished%20product%20being%20loaded%20for%20delivery%2C%20industrial%20material%20handling%2C%20efficient%20logistics%20operation%2C%20professional%20freight%20loading%2C%20corporate%20photography%20style%20showing%20quality%20and%20care&width=480&height=320&seq=tmi-logistics-3&orientation=landscape',
      type: 'FINISHED PRODUCT DELIVERY',
      title: 'Chrome Concentrate Distribution',
      description: 'Timely delivery of finished chrome concentrate from our Rustenburg plant directly to clients. Our JIT delivery model ensures your production schedule stays on track with reliable, scheduled deliveries.',
      capacity: 'JIT',
      unit: 'DELIVERY',
      features: [
        'Just-in-time delivery model',
        'Direct plant-to-client transport',
        'Quality preservation',
        'Flexible scheduling'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=logistics%20coordination%20and%20route%20planning%20for%20mining%20operations%2C%20supply%20chain%20management%2C%20efficient%20transportation%20scheduling%2C%20professional%20operations%20center%2C%20corporate%20photography%20showing%20organization%20and%20efficiency&width=480&height=320&seq=tmi-logistics-6&orientation=landscape',
      type: 'SUPPLY CHAIN',
      title: 'End-to-End Coordination',
      description: 'Comprehensive logistics management from raw material sourcing to finished product delivery. Our experienced team coordinates all aspects of transportation to ensure seamless operations and timely delivery.',
      capacity: '24/7',
      unit: 'SUPPORT',
      features: [
        'Full supply chain visibility',
        'Route optimization',
        'Load coordination',
        'Real-time communication'
      ]
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 font-['Montserrat']">
            <span className="text-black">LOGISTICS </span>
            <span className="text-[#8B1538]">SERVICES</span>
          </h2>
          <p className="text-lg text-gray-600 font-['Lato'] max-w-3xl mx-auto">
            Comprehensive transportation solutions tailored for chrome processing operations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#FAF8F5] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="h-2 bg-[#8B1538]"></div>
              <div className="w-full h-[320px] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="text-sm text-[#8B1538] uppercase tracking-wider mb-2 font-semibold">
                  {service.type}
                </div>
                <h3 className="text-2xl font-bold text-[#2C3E50] mb-4 leading-tight">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="flex items-end gap-2 mb-6 pb-6 border-b border-gray-200">
                  <span className="text-4xl font-bold text-[#8B1538]">{service.capacity}</span>
                  <span className="text-sm text-gray-500 mb-2">{service.unit}</span>
                </div>

                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#8B1538] text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}